import BasePropertyView from 'BasePropertyView.js';
import contentTemplate from 'dashboard/settings/source-url-table-view.ejs';
import NotificationService from 'NotificationService';
import util from 'util/Util';
import guidUtil from 'util/GuidUtil';
import RestService from 'RestService';
import constants from 'Constants.js';
import FormLoadService from 'FormLoadService';
import xjService from 'xml/XJService';
import zLib from 'util/ZLib';
import userService from 'UserService';
import listService from 'ListService';

class SourceURLTableView extends BasePropertyView {

    initialize(opts) {

        this.options = opts || {};
        this.template = contentTemplate;

        this.events = {
            'click #new-source' : 'addNewSource'
        };

        this.listenTo(this.model, 'change', this.render);
        this.notifications = [];

        const isBULicense = util.isTrue(listService.accountSettings.IsBULicense);
        const featureEnabled = isBULicense ? util.isTrue(userService.checkFeatures("WSSource")) : true;

        this.model.set("featureEnabled", featureEnabled, {silent:true});

        return this;
    }

    addNewSource(){
        const $table = $('#sources-table');
        $table.bootstrapTable('insertRow', {
            index: 0,
            row: {
                '@Source': 'newSource:',
                '@Connections': 0
            }
          })
    }

    bindIconsEvents(){
        const table = $('#sources-table');
        const self = this;

        window.SourcesOptionsEv = {
            'click .edit': function (e, value, row, index) {
                //Edit source
                table.bootstrapTable('updateCell', {
                    index: index,
                    field: "@Source",
                    value: "editMode:" + row['@Source']
                });
            },
            'click .delete': function (e, value, row, index) {
                //delete source
                const connCount = parseInt(row['@Connections']);
                
                if(connCount > 0){
                    self.getConnections(row['@WsSourceId'], 'd');                        
                }
                else{
                    table.bootstrapTable('remove', {
                        field: '$index',
                        values: [index]
                      });

                      self.updateWSSource(index, row, null, 'd');
                }
            }
        }
    }
    
    createTable() {
        const table = $('#sources-table');
        this.bindIconsEvents();
        const self = this;
        const startTable = () => {
            table.bootstrapTable({
                pagination: true,
                paginationParts: ['pageInfo', 'pageList'],
                classes: 'table table-hover table-striped table-borderless',
                columns: [
                {
                    field: '@WsSourceId',
                    visible: false
                },
                {
                    field: '@Source',
                    title: 'Source',
                    visible: true,
                    width: 665,
                    formatter: (value, row, index) => {

                        const editMode = value.indexOf("editMode") >= 0;
                        const newRow = value.indexOf("newSource") >= 0;

                        if (editMode || newRow) {

                            let newValue = editMode ? value.replace(/editMode:/g, "") : value.replace(/newSource:/g, "");

                            setTimeout(() => {
                                self.validateSource(table, row, newValue, editMode, index);
                            }, 150);

                            return '<input id="editSource" type="text" value="' + newValue + '"/>';
                        } else {
                            return '<div class="truncate-text" title="' + value + '">' + value + '</div>';
                        }
                    }
                },
                {
                    field: '@Connections',
                    title: 'Connections',
                    align: 'center',
                    visible: true,
                    formatter: (value, row, index) => {
                        return [
                            '<div>' + row['@Connections'] + '</div>'
                        ].join('');
                    }
                },
                {
                    field: 'functions',
                    title: '',
                    align: 'center',
                    clickToSelect: false,
                    events: SourcesOptionsEv,
                    formatter: (value, row, index) => {
                        return [
                            '<i class="pf-icon-edit edit" title="Edit Source"></i>',
                            '<i class="pf-delete delete" title="Delete Source"></i>'
                        ].join('');
                    }
                }],
                data: self.model.get("data"),
                onDblClickCell: (field, value, row, $element) => {
                    const index = $element.parent().data().index;
                    table.bootstrapTable('updateCell', {
                        index: index,
                        field: field,
                        value: "editMode:" + value
                    });
                }
            });

            let paginationText = $(".pagination-info").text().replace("rows", "sources");
            $(".pagination-info").text(paginationText);
        }
        startTable();
    }

    updateWSSource(index, row, wsSource, mode){
        const self = this;

        switch(mode){
            case 'i': //insert
                RestService.createWSSource(wsSource).then((result)=> {
                    const table = $('#sources-table');
                    table.bootstrapTable('updateCell', {
                        index: index,
                        field: '@WsSourceId',
                        value: result.WSSourceId || 0
                    });

                    self.checkMax();
                }).catch((err=> {
                    NotificationService.error(err);
                }));
            break;
            case 'u'://update
                RestService.updateWSSource(parseInt(row['@WsSourceId']), wsSource).then((result)=> {
                    console.log(result);
                }).catch((err=> {
                    NotificationService.error('Error updating web source ' + err + '. Please try again.');
                }));
            break;
            case 'd'://delete
                RestService.deleteWSSource(parseInt(row['@WsSourceId'])).then((result)=> {
                    console.log(result);
                    self.checkMax();
                }).catch((err=> {
                    NotificationService.error('Error deleting web source ' + err + '. Please try again.');
                }));
            break;
        }
    }

    getConnections(sourceId, mode, newVal, updateSource, cancel){
        RestService.getWSSourceConnections(sourceId).then((result) => {

            const connections = result;
            let options = "", type = "", permissions = '';
            let canEdit = 0, highlight = "";
                     
            $.each(connections, function (i, item) {

                if(mode === "d"){
                    type = item['@Type'] === "3" ? "SOAP Web Service - " : "REST Web Service - "
                    options += '<li>' + type + item['@Name'] + '</li>';
                }else{
                    permissions = item["UserPermissionsXML"].Permissions;

                    if ((permissions["@administer"] && permissions["@administer"] === "allow") || (permissions["@edit"] && permissions["@edit"] === "allow")) {
                        canEdit++;
                        highlight = ""
                    }
                    else {
                        highlight = "style='color:#FF0000;'";
                    }
                    type = item['@Type'] === "3" ? "SOAP Web Service - " : "REST Web Service - "
                    options += '<li ' + highlight + '>' + type + item['@Name'] + '</li>';
                }
            });

            $(".connection_list").html(options);

            let title = "";
            let buttons = [];

            switch (mode) {
                case 'e': //edit

                    if (connections.length === canEdit) {
                        $("#connModal-content").html("Changing the current URL will update all connections, which may cause them to stop working. If you wish to proceed, please type 'CONFIRM' in all caps in the input field below.<br/>\
                                                                    <br/>\
                                                                <input type='text' id='confirmEditSource' />");
                        buttons = [{
                            text: 'Ok',
                            'class': 'btn-select-field',
                            click: () => {
                                updateSource(this.dialog, connections, newVal);
                            }
                        }, {
                            text: 'Cancel',
                            'class': 'btn-select-field',
                            click: () => {
                                this.dialog.dialog("close");
                                cancel();
                            }
                        }];
                    }
                    else {//If the user does not have edit permissions on one or more connections
                        $("#connModal-content").html("You don't have edit permissions for the highlighted connections. Please contact the connection owner or the account administrator to request the necessary changes.");
                        buttons = [{
                            text: 'Ok',
                            'class': 'btn-select-field',
                            click: () => {
                                this.dialog.dialog("close");
                                cancel();
                            }
                        }];
                    }
                    title = "Update source URL";
                    
                    break;
                case 'd': //delete

                    $("#connModal-content").html("Please remove it from those connections or delete the connections before attempting to delete the source.");
                    title = "Can't delete source";

                    buttons = [{
                        text: 'Ok',
                        'class': 'btn-select-field',
                        click: () => {
                            this.dialog.dialog("close");
                        }
                    }];

                break;
            }                        

            //show modal with connections details
            this.dialog = util.newDashboardModal("#existingConnectionsModal",
                {
                    title: title,
                    hideTitleBar: false,
                    closeEsc: true,
                    width: 515,
                    titleBarClass: "dashboard-modal-dialog-titlebar-notification",
                    titleClass: "dashboard-modal-title-notification",
                    buttons: buttons
                }).dialog("open");
            this.dialog.dialog("option", "position", { my: "center center-100", at: "center", of: window });
        }).catch((err => {
            NotificationService.error('Error getting web source connections: ' + err + '. Please try again.');
        }));
    }

    checkMax (){
        const table = $('#sources-table');
        const limit = this.model.get("sourcesLimit");
        const data = table.bootstrapTable('getData');
        const maxReached = limit && limit <= data.length;

        if(maxReached){
            $("#newSource").hide();
            $("#maxSourcesReached").show();
        }else{
            $("#newSource").show();
            $("#maxSourcesReached").hide();
        }

    }

   
    validateSource(table, row, value, editMode, index) {

        const self = this;
      
        const $cell = $("#editSource");
        $cell.trigger('select');

        
        const updateTable = (newVal) =>{
            table.bootstrapTable('updateCell', {
                index: index,
                field: '@Source',
                value: newVal
            });
        }

        const cancel = () =>{
            table.bootstrapTable('updateCell', {
                index: index,
                field: '@Source',
                value: value
            });
        }
        
        const deleteRow = () =>{
            table.bootstrapTable('remove', {
                field: '$index',
                values: [index]
              });
        }

        const updateSource = (dialog, currentConnections, newVal) =>{
            if($("#confirmEditSource").val() === "CONFIRM"){
                console.log(currentConnections);
                let continueUpdate = true;
                let connectionsUpdated = [];

                //Update all connections
                $.each(currentConnections, function (i, item) {
                    this.waitToUpdate = setInterval(() => {
                        if (continueUpdate) {
                            continueUpdate = false;
                            let connectionXML = FormLoadService._decompressForm(item.ConnectionXML['#cdata-section']);
                            const connectionObject = xjService.toJSON(connectionXML);

                            connectionObject.Connection["_url"] = newVal;

                            const XMLObject = xjService.toXML(connectionObject);

                            const updateParameters = {
                                connectionId: item["@ConnectionId"],
                                name: self.model.get("accountName"),
                                connectionXML: zLib.compressForm(XMLObject)
                            };

                            RestService.updateConnectionServiceURL(updateParameters).then((data) => {
                                connectionsUpdated.push(item["@ConnectionId"]);
                            }).catch((err) => {
                                console.log('Error on update: ', err);
                                if (err.MESSAGE) {
                                    NotificationService.error(err.MESSAGE);
                                }
                            }).finally(() => {
                                clearInterval(this.waitToUpdate);     
                                continueUpdate = true;  
                            })
                        }
                    }, 100);
                });

                this.waitToFinish = setInterval(() => {
                    if(connectionsUpdated.length === currentConnections.length){
                        NotificationService.success("The connections' service url have been successfully updated.");
                        updateTable(newVal);
                        self.updateWSSource(index, row, newVal, 'u');
                        dialog.dialog("close");
                        $("#confirmEditSource").val("");
                        clearInterval(this.waitToFinish);   
                    }
                }, 100);
            }
        }

        const updateCell = (newVal, esc) =>{

            if (newVal === "") {
                if (!editMode) {//If new row and empty value remove row
                    deleteRow();
                }
                else{//leave original value
                    cancel();
                }
            } else {
                
                newVal = newVal.trim().replace(/^(https?):/i, (match, p1) => p1.toLowerCase() + ':');
                if(esc || newVal === value){
                    cancel();
                }
                else {
                    const data = table.bootstrapTable('getData');
                    const exists = data.find((v) => v['@Source'] === newVal);

                    if (!exists) {
                        //check valid URL
                        let valid = false;
                       
                        try {
                            new URL(newVal); // Will throw if URL is invalid
                            valid = true;

                            if(newVal.toLowerCase().indexOf("mailto") >= 0 || newVal.toLowerCase().indexOf("ftp") >= 0){ //mailto and ftp should not be valid urls
                                valid = false;
                            }
                        } catch (err) {
                            valid = false;
                        }
                        
                          const connectionCount = parseInt(row['@Connections']);

                        if (valid) {
                           
                            if (editMode) {
                                //check if it has connections
                                if (connectionCount > 0) {

                                    self.getConnections(row['@WsSourceId'], 'e', newVal, updateSource, cancel);

                                } else {
                                    updateTable(newVal);
                                    self.updateWSSource(index, row, newVal, 'u');
                                }
                            }else {
                                const limit = this.model.get("sourcesLimit");
                                const data = this.model.get("data").length;

                                if (limit !== 0 && limit > data) {
                                    updateTable(newVal);
                                    self.updateWSSource(index, row, newVal, 'i');
                                }else{
                                    NotificationService.error("You've reached the maximum number of REST and SOAP service sources allowed for this account. Please contact " + listService.salesEmailAddress + " if you need additional access.");
                                }
                            }
                        } else {
                            $cell.trigger('select');
                            this.notifyError("The URL format is not valid. Please check and try again. Press ESC to cancel.");
                        }
                    } else {
                        deleteRow();
                        this.notifyError("The URL you entered already exists in the sources table.")
                    }
                }
            }
        }        

        $cell.on("keydown", (e) => { 
            if (e.which == 27) {//If the user presses esc the value is not set
                if (!editMode) {
                    deleteRow();
                } else {
                    updateCell(value, true);                    
                }
            }else if(e.which == 13){//on enter
                 updateCell($cell.val());    
            }
        });

        $cell.on("focusout", () => {
            updateCell($cell.val());
        });
    }

    notifyError(message){
        const existingAlerts = $(".alert-content");
        const currentExists = existingAlerts.length > 0 ? existingAlerts.filter((i,a) => a.innerText.indexOf(message) >= 0) : false;

        if(!currentExists){
            NotificationService.error(message);
        }
    }

    render() {
        const html = this.template(this.model.toJSON());

        $(this.$el[0]).html(html);

        if(this.model.get("featureEnabled")){
            this.createTable();
        }
       
        this.delegateEvents();
        this.$el.css('cursor', 'default');
        return this;
    }

}

export default SourceURLTableView;